import Settingsv2 from "./Settingsv2";

export default Settingsv2;
